<template>
  <div class="db relative w-100 h-100 nav-wrapper">
    <div class="flex relative w-100 h-100 flex-column justify-center">
      <nav class="db relative mv4 ph4 tl">
        <div class="relative mv2 pv1">
          <router-link class="relative no-underline is-tablet-bold is-cream nav-primary" to="/" v-on:click.native="closeNavBusMethod()" title="Outside Lands Home">
            <span class="relative z-0 f2 text">
              Home
            </span>
          </router-link>
        </div>
        <div class="relative mv2 pv1" v-for="(item, index) in navigation.navigation_items" :class="{'dn' : !item.is_published }" :key="'mobile-nav-item' + index">
          <a v-if="item.title === 'Merch'" class="relative no-underline is-tablet-bold is-cream nav-primary" :href="item.link" target="_blank" :title="item.title" :id="item.id">
            <span v-if="item.is_primary" class="relative z-0 f2 text">
              {{ item.title }}
            </span>
            <span v-else class="relative z-0 f3 text">
              {{ item.title }}
            </span>
          </a>
          <router-link v-else class="relative no-underline is-tablet-bold is-cream nav-primary" :to="item.link" v-on:click.native="closeNavBusMethod()" :title="item.title" :id="item.id">
            <span v-if="item.is_primary" class="relative z-0 f2 text">
              {{ item.title }}
            </span>
            <span v-else class="relative z-0 f3 text">
              {{ item.title }}
            </span>
          </router-link>
        </div>
      </nav>
    </div>
    <div class="db absolute bottom-0 left-0 w-100 mw20rem ml4 mb2">
      <div class="relative flex flex-row items-center justify-between">
        <a class="dib relative pointer social-icon is-teal-icon" v-for="social in footer_content.socials" :href="social.link" target="_blank" :key="social.title" :title="social.title">
          <span class="icon" v-html="social.icon_svg"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {bus} from '../../assets/js/src/main';
export default {
  props: ['menuIconIsClicked'],
  data() {
    return {
      //
    }
  },
  computed: {
    navigation: function () {
      var contentData = this.$store.getters.filterPagesByName('main-navigation.markdown');
      return contentData[0];
    },
    footer_content: function () {
      var footerContentData = this.$store.getters.filterPagesByName('footer.markdown');
      return footerContentData[0];
    } 
  },
  methods: {
    closeNavBusMethod() {
      bus.$emit('closeNavBus');
    }
  }
}
</script>
